import { Observable, of } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';

export interface LangChangeEvent {
    lang: string;
    translations: any;
}

@Injectable()
export class TranslationServiceMock {

    public onLangChange: EventEmitter<LangChangeEvent> = new EventEmitter<LangChangeEvent>();

    addTranslationFolder() {

    }

    // Just returns an Observable of the language string literal.
    public use(lang: string): Observable<any> {
        return of(lang);
    }

    public get(key: string|Array<string>, interpolateParams?: Object): Observable<string|any> {
        return of(key);
    }
}
